import { render } from "./MeetingCard.vue?vue&type=template&id=50c9c9bd&scoped=true"
import script from "./MeetingCard.vue?vue&type=script&lang=js"
export * from "./MeetingCard.vue?vue&type=script&lang=js"

import "./MeetingCard.vue?vue&type=style&index=0&id=50c9c9bd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c9c9bd"]])

export default __exports__